import { render, staticRenderFns } from "./create-users.vue?vue&type=template&id=f6af2f84&scoped=true&style=padding-left%3A100px%3B&"
import script from "./create-users.vue?vue&type=script&lang=js&"
export * from "./create-users.vue?vue&type=script&lang=js&"
import style0 from "./create-users.vue?vue&type=style&index=0&id=f6af2f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6af2f84",
  null
  
)

export default component.exports